import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { clearMessageModal, messageModalSelector } from "../state";
import { MessageModal as MessageModalComponent } from "../components/MessageModal";

export const MessageModal = () => {
  const dispatch = useDispatch();
  const { message, buttons } = useSelector(messageModalSelector);

  if (!message) return null;

  return (
    <MessageModalComponent
      handleClose={() => dispatch(clearMessageModal())}
      title={message?.title}
      icon={message?.icon}
      buttons={buttons}
      message={message?.body}
      status={message?.status}
    />
  );
};
